import {
  StoreSelector,
  useAppStoreSelector,
} from '../../../shared/store/model/context';
import { LoadingState } from '../../../shared/store/model/types';
import { AuthSlice } from './types';

type AuthStoreState = AuthSlice & {
  loading: LoadingState;
};

type AuthStoreSelector<T> = StoreSelector<AuthStoreState, T>;

export const authSelectors = {
  requestPhoneCode: (state) => state.requestPhoneCode,
  verifyPhoneCode: (state) => state.verifyPhoneCode,
  requestPasswordOperationCode: (state) => state.requestPasswordOperationCode,
  loginWithPassword: (state) => state.loginWithPassword,
  registerWithPassword: (state) => state.registerWithPassword,
  recoverPassword: (state) => state.recoverPassword,
  authLoading: (state) => state.loading.auth,
} satisfies Record<string, AuthStoreSelector<unknown>>;

export function useAuthStore<T>(selector: AuthStoreSelector<T>) {
  return useAppStoreSelector(selector);
}
